import { Spinner } from '@app/components/various/Spinner';

export const SelectionImportLoader = () => <Spinner className="size-10" />;
